import type { ToastOptions } from "react-toastify";

export const IS_PRODUCTION = true

const DS_URL_LIVE = "https://signage.mycircle.net/api/"
// const DS_URL_LIVE = "http://localhost:7000/api/"
const DS_URL_REACT = "https://dsapi.menspal.com/api/"


let isMycircle = true
const domainName: any = window.location.hostname
const domain = domainName?.startsWith("localhost") ? "menuonline.com" : domainName?.match(/^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/)[1];

let MYCIRCLE_UPLOAD_URL1 = "https://cdn.menuonline.com/preview/mycircle-digital-signage-2/"

let EDITOR_URL_REACT1 = IS_PRODUCTION ? "https://editor.menuonline.com/" : "https://neweditor.menspal.com/"
let EDITOR_URL_BACKEND1 = IS_PRODUCTION ? "https://editor.menuonline.com/" : "https://neweditor.menspal.com/"
let FREE_EDITOR_URL1 = IS_PRODUCTION ? "https://canvas.menuonline.com/" : "https://fe.menspal.com/"

let DS_URL1 = IS_PRODUCTION ? DS_URL_LIVE : DS_URL_REACT
let MYCIRCLE_URL1 = IS_PRODUCTION ? "https://menuonline.com" : "https://menspal.com"
let SALE_URL1 = IS_PRODUCTION ? "https://sales.mycircle.net" : "https://sales.menspal.com"
let DS_FRONTEND_URL1 = IS_PRODUCTION ? "https://ds.menuonline.com" : "https://ds.menspal.com"
let UPLOAD_FOLDER1 = "uploads/"

if (domain === "scheduledown.com") {
  isMycircle = false
  EDITOR_URL_REACT1 = IS_PRODUCTION ? "https://editor.scheduledown.com/" : "https://neweditor.scheduledown.com/"
  EDITOR_URL_BACKEND1 = IS_PRODUCTION ? "https://editor.scheduledown.com/" : "https://neweditor.scheduledown.com/"
  DS_URL1 = IS_PRODUCTION ? "https://signage.scheduledown.com/api/" : "https://devsignage.scheduledown.com/api/"
  MYCIRCLE_URL1 = IS_PRODUCTION ? "https://scheduledown.com" : "https://beta.scheduledown.com"
  SALE_URL1 = IS_PRODUCTION ? "https://sales.scheduledown.com" : "https://salesbeta.scheduledown.com"
  DS_FRONTEND_URL1 = IS_PRODUCTION ? "https://ds.scheduledown.com" : "https://ds-dev.scheduledown.com"
  UPLOAD_FOLDER1 = "scheduledown_uploads/"
  MYCIRCLE_UPLOAD_URL1 = "https://cdn.menuonline.com/preview/mycircle-digital-signage-2/"
}

export const IS_MYCIRCLE = isMycircle
export const MYCIRCLE_UPLOAD_URL = MYCIRCLE_UPLOAD_URL1
export const EDITOR_URL_REACT = EDITOR_URL_REACT1 // IS_PRODUCTION ? "https://editor.mycircle.net/" : "https://neweditor.menspal.com/"
export const EDITOR_URL_BACKEND = EDITOR_URL_BACKEND1 // IS_PRODUCTION ? "https://editor.mycircle.net/" : "https://neweditor.menspal.com/"
export const FREE_EDITOR_URL = FREE_EDITOR_URL1

export const DS_URL = DS_URL1 // IS_PRODUCTION ? DS_URL_LIVE : DS_URL_REACT
export const MYCIRCLE_URL = MYCIRCLE_URL1 // IS_PRODUCTION ? "https://mycircle.net" : "https://menspal.com"
export const SALE_URL = SALE_URL1 // IS_PRODUCTION ? "https://sales.mycircle.net" : "https://sales.menspal.com"

export const DEMO_USER_ID = IS_PRODUCTION ? 1325 : 4;
export const DEMO_USER_ACCOUNT_ID = IS_PRODUCTION ? '65d7322dec8aa4079192f78d' : '6378675e80a81c1e868c213a';
export const FONT_URL = DS_URL_LIVE
export const DS_FRONTEND_URL = DS_FRONTEND_URL1 // IS_PRODUCTION ? "https://ds.mycircle.net" : "https://newds.tjcg.in"
export const UPLOAD_FOLDER = UPLOAD_FOLDER1
export const CURRENT_FRONT_URL = window.location.origin

export const PUBLIC_CAT_ID = IS_PRODUCTION ? "622622d96a6deb5858dd3deb" : "622622d96a6deb5858dd3deb"




export const toastConfig: ToastOptions = {
  position: "top-center",
  theme: "colored",
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: false,
  progress: undefined,
  closeButton: false,
}